export const ROLES_LIST = [
  { value: 'user', label: 'Usuario' },
  { value: 'admin', label: 'Admin (Coordinación)' },
  { value: 'executive', label: 'Ejecutivo (C-level)' },
  { value: 'space_manager', label: 'Responsable de espacio' },
] as const;
